import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface LeftViewState {

  showOverlay: boolean;
};

const initialState: LeftViewState = {
    showOverlay: false,
};

const bottomViewSlice = createSlice({
  name: "bottomView",
  initialState,
  reducers: {

    setShowOverlay: (state, action: PayloadAction<boolean>) => {
      state.showOverlay = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const { setShowOverlay } = bottomViewSlice.actions;
export const selectBottomView = (state: any) => state.bottomView;
export default bottomViewSlice.reducer;